import {
  ITelegramIdsCreateProps,
  ITelegramIdsFilterProps,
  ITelegramIdsProps,
  ITelegramIdsSimpleProps,
  ITelegramIdsUpdateParams,
} from './types';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';

const ENDPOINT = 'v1/telegram/ids';

export const createTelegramIdAsync = async (
  data: ITelegramIdsCreateProps,
): Promise<ITelegramIdsProps> => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateTelegramIdAsync = async ({
  id,
  data,
}: ITelegramIdsUpdateParams): Promise<ITelegramIdsProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteTelegramIdAsync = async (id: number) => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getTelegramIdByIdAsync = async (
  id: number,
): Promise<ITelegramIdsProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllTelegramIdsByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: ITelegramIdsFilterProps,
): Promise<ITelegramIdsSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllTelegramIdsByLicenseCountAsync = async (
  filter: ITelegramIdsFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
